/**
 * Header Cart Sidebar Functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  const cartToggleBtn = document.querySelector('[data-cart-toggle]');
  const cartSidebar = document.querySelector('[data-cart-sidebar]');
  const cartCloseElements = document.querySelectorAll('[data-cart-close]');
  
  // Open cart sidebar
  if (cartToggleBtn) {
    cartToggleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
  }
  
  // Close cart sidebar
  cartCloseElements.forEach(element => {
    element.addEventListener('click', function() {
      closeCart();
    });
  });
  
  // Remove item from cart
  setupRemoveButtons();
  
  // Initialize cart sidebar footer on page load
  initializeCartSidebar();

  // Search functionality with live results
  const searchForm = document.querySelector('.search-box');
  const searchInput = document.querySelector('.search-input');
  const searchResults = document.querySelector('.search-results');
  let searchTimeout;

  if (searchInput && searchResults) {
    // Handle input for live search
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      const query = this.value.trim();
      
      if (query.length < 2) {
        searchResults.classList.remove('active');
        searchResults.innerHTML = '';
        return;
      }
      
      searchTimeout = setTimeout(() => {
        fetchSearchResults(query);
      }, 300);
    });
    
    // Handle focus
    searchInput.addEventListener('focus', function() {
      this.style.borderColor = '#0066ff';
      if (this.value.trim().length >= 2) {
        searchResults.classList.add('active');
      }
    });
    
    // Handle blur with delay to allow click on results
    searchInput.addEventListener('blur', function() {
      setTimeout(() => {
        searchResults.classList.remove('active');
        if (this.value.trim() === '') {
          this.style.borderColor = '';
        }
      }, 200);
    });
  }

  // Fetch search results
  function fetchSearchResults(query) {
    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
      .then(response => response.json())
      .then(data => {
        displaySearchResults(data.resources.results.products);
      })
      .catch(error => {
        console.error('Search error:', error);
        searchResults.innerHTML = '<div class="search-no-results">Error loading results</div>';
        searchResults.classList.add('active');
      });
  }

  // Display search results
  function displaySearchResults(products) {
    if (!products || products.length === 0) {
      searchResults.innerHTML = '<div class="search-no-results">No products found</div>';
      searchResults.classList.add('active');
      return;
    }
    
    let html = '<div class="search-results-header">Products</div>';
    
    products.forEach(product => {
      const price = (product.price / 100).toFixed(2);
      const image = product.image || product.featured_image;
      
      html += `
        <a href="${product.url}" class="search-result-item">
          <div class="search-result-image">
            <img src="${image}" alt="${product.title}" loading="lazy">
          </div>
          <div class="search-result-info">
            <div class="search-result-title">${product.title}</div>
            <div class="search-result-price">₹${price}</div>
          </div>
        </a>
      `;
    });
    
    searchResults.innerHTML = html;
    searchResults.classList.add('active');
  }

  if (searchForm) {
    searchForm.addEventListener('submit', function(e) {
      if (searchInput && searchInput.value.trim() === '') {
        e.preventDefault();
        searchInput.focus();
        searchInput.style.borderColor = '#ff4444';
        
        setTimeout(() => {
          searchInput.style.borderColor = '';
        }, 1000);
      }
    });
  }

  // Mobile menu toggle
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mainNav = document.querySelector('.main-nav');
  const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
  const megaMenuTriggers = document.querySelectorAll('.mega-menu-trigger');
  const mobileMenuCloseBtn = document.querySelector('.mobile-menu-close-btn');

  if (mobileMenuBtn && mainNav) {
    mobileMenuBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      mainNav.classList.toggle('active');
      mobileMenuBtn.classList.toggle('active');
      
      if (mobileMenuOverlay) {
        mobileMenuOverlay.classList.toggle('active');
      }
      
      // Prevent body scroll when menu is open
      if (mainNav.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
  }

  // Close mobile menu with close button
  if (mobileMenuCloseBtn) {
    mobileMenuCloseBtn.addEventListener('click', function() {
      mainNav.classList.remove('active');
      mobileMenuBtn.classList.remove('active');
      if (mobileMenuOverlay) {
        mobileMenuOverlay.classList.remove('active');
      }
      document.body.style.overflow = '';
    });
  }

  // Close mobile menu when overlay is clicked
  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', function() {
      mainNav.classList.remove('active');
      mobileMenuBtn.classList.remove('active');
      mobileMenuOverlay.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  // Mobile Search Sidebar Toggle
  const mobileSearchBtn = document.querySelector('.mobile-search-btn');
  const searchSidebar = document.querySelector('[data-search-sidebar]');
  const searchCloseElements = document.querySelectorAll('[data-search-close]');
  
  if (mobileSearchBtn && searchSidebar) {
    mobileSearchBtn.addEventListener('click', function(e) {
      e.preventDefault();
      searchSidebar.classList.add('active');
      document.body.style.overflow = 'hidden';
      
      // Focus input
      const mobileSearchInput = searchSidebar.querySelector('.search-input');
      if (mobileSearchInput) {
        setTimeout(() => {
          mobileSearchInput.focus();
        }, 300);
      }
    });
  }
  
  // Close search sidebar
  searchCloseElements.forEach(element => {
    element.addEventListener('click', function() {
      if (searchSidebar) {
        searchSidebar.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });

  // Mobile mega menu toggle (Shop All)
  megaMenuTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      // Only toggle on mobile
      if (window.innerWidth <= 1023) {
        e.preventDefault();
        e.stopPropagation();
        
        // Close other mega menus
        megaMenuTriggers.forEach(t => {
          if (t !== trigger) {
            t.classList.remove('active');
          }
        });
        
        // Toggle current mega menu
        this.classList.toggle('active');
      }
    });
  });

  // Mobile Mega Menu Accordion (Categories)
  const megaMenuCategories = document.querySelectorAll('.mega-menu-category h3');
  megaMenuCategories.forEach(header => {
    header.addEventListener('click', function(e) {
      if (window.innerWidth <= 1023) {
        e.stopPropagation();
        const category = this.parentElement;
        category.classList.toggle('active');
      }
    });
  });

  // Close mobile menu on window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth > 1023) {
      mainNav.classList.remove('active');
      mobileMenuBtn.classList.remove('active');
      if (mobileMenuOverlay) {
        mobileMenuOverlay.classList.remove('active');
      }
      document.body.style.overflow = '';
      
      // Remove active class from mega menu triggers
      megaMenuTriggers.forEach(trigger => {
        trigger.classList.remove('active');
      });
    }
  });
});

// Initialize cart sidebar footer on page load
function initializeCartSidebar() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartSidebarFooter = document.querySelector('.cart-sidebar-footer');
      
      // If cart has items, ensure footer is visible and populated
      if (cart.item_count > 0) {
        let footer = cartSidebarFooter;
        if (!footer) {
          footer = document.createElement('div');
          footer.className = 'cart-sidebar-footer';
          const content = document.querySelector('.cart-sidebar-content');
          if (content) content.appendChild(footer);
        }

        if (footer) {
          const totalPrice = (cart.total_price / 100).toFixed(2);
          footer.innerHTML = `
            <div class="cart-total">
              <span>Total:</span>
              <span class="cart-total-price">₹${totalPrice}</span>
            </div>
            <a href="/checkout" class="mz-btn mz-btn-primary checkout-btn">Proceed to Checkout</a>
            <a href="/cart" class="mz-btn mz-btn-outline">View Cart</a>
          `;
          footer.style.display = 'block';
        }
      }
    })
    .catch(error => console.error('Error initializing cart sidebar:', error));
}

function openCart() {
  const cartSidebar = document.querySelector('[data-cart-sidebar]');
  if (cartSidebar) {
    cartSidebar.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}

function closeCart() {
  const cartSidebar = document.querySelector('[data-cart-sidebar]');
  if (cartSidebar) {
    cartSidebar.classList.remove('active');
    document.body.style.overflow = '';
  }
}

function setupRemoveButtons() {
  document.querySelectorAll('[data-remove-item]').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const key = this.getAttribute('data-remove-item');
      const cartItem = this.closest('.cart-item');
      
      // Add loading state
      if (cartItem) {
        cartItem.style.opacity = '0.5';
        cartItem.style.pointerEvents = 'none';
      }
      
      removeCartItem(key, cartItem);
    });
  });
}

function removeCartItem(key, cartItemElement) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: key,
      quantity: 0
    })
  })
  .then(response => response.json())
  .then(cart => {
    // Animate removal
    if (cartItemElement) {
      cartItemElement.style.transform = 'translateX(100%)';
      cartItemElement.style.opacity = '0';
      
      setTimeout(() => {
        cartItemElement.remove();
        
        // Update cart count
        updateCartCount(cart.item_count);
        
        // Update total price
        updateCartTotal(cart.total_price);
        
        // Check if cart is empty
        if (cart.item_count === 0) {
          showEmptyCart();
        }
      }, 300);
    }
  })
  .catch(error => {
    console.error('Error removing item:', error);
    if (cartItemElement) {
      cartItemElement.style.opacity = '1';
      cartItemElement.style.pointerEvents = 'all';
      alert('Failed to remove item. Please try again.');
    }
  });
}

function updateCartCount(count) {
  const cartCount = document.querySelector('.cart-count');
  if (cartCount) {
    cartCount.textContent = count;
    
    // Animate count update
    cartCount.style.transform = 'scale(1.3)';
    setTimeout(() => {
      cartCount.style.transform = 'scale(1)';
    }, 200);
  }
}

function updateCartTotal(totalPrice) {
  const cartTotalPrice = document.querySelector('.cart-total-price');
  if (cartTotalPrice) {
    // Format price (assuming Shopify's money format)
    const formattedPrice = formatMoney(totalPrice);
    cartTotalPrice.textContent = formattedPrice;
  }
}

function formatMoney(cents) {
  // Basic money formatting - adjust based on your currency
  const amount = (cents / 100).toFixed(2);
  return 'Rs. ' + amount;
}

function showEmptyCart() {
  const cartSidebarBody = document.querySelector('.cart-sidebar-body');
  const cartSidebarFooter = document.querySelector('.cart-sidebar-footer');
  
  if (cartSidebarBody) {
    cartSidebarBody.innerHTML = `
      <div class="cart-empty">
        <i class="fas fa-shopping-cart"></i>
        <p>Your cart is empty</p>
        <a href="/collections/all" class="mz-btn mz-btn-primary">Continue Shopping</a>
      </div>
    `;
  }
  
  if (cartSidebarFooter) {
    cartSidebarFooter.style.display = 'none';
  }
}

// AJAX Add to Cart Functionality - Using Event Delegation
document.addEventListener('submit', function(e) {
  // Check if the submitted form has the ajax class
  if (e.target.classList.contains('ajax-add-to-cart-form')) {
    e.preventDefault();
    
    const form = e.target;
    const formData = new FormData(form);
    const submitButton = form.querySelector('button[type="submit"]');
    const originalText = submitButton.textContent;
    
    // Disable button and show loading state
    submitButton.disabled = true;
    submitButton.textContent = 'Adding...';
    
    // Send AJAX request to Shopify cart API
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      
      // Show success message
      submitButton.textContent = '✓ Added!';
      submitButton.style.background = '#22c55e';
      
      // Update cart count and sidebar contents
      updateCartCountAjax();
      refreshCartSidebar();
      
      // Reset button after 2 seconds
      setTimeout(() => {
        submitButton.textContent = originalText;
        submitButton.disabled = false;
        submitButton.style.background = '';
      }, 2000);
      
      // Show notification
      showAddToCartNotification(data);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      submitButton.textContent = 'Error - Try Again';
      submitButton.disabled = false;
      
      setTimeout(() => {
        submitButton.textContent = originalText;
      }, 2000);
    });
  }
});

// Update cart count function
function updateCartCountAjax() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        
        // Animate cart icon
        cartCount.style.transform = 'scale(1.3)';
        setTimeout(() => {
          cartCount.style.transform = 'scale(1)';
        }, 300);
      }
    })
    .catch(error => console.error('Error updating cart count:', error));
}

// Refresh cart sidebar with updated items
function refreshCartSidebar() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartSidebarBody = document.querySelector('.cart-sidebar-body');
      const cartSidebarFooter = document.querySelector('.cart-sidebar-footer');
      
      if (!cartSidebarBody) return;
      
      // If cart is empty
      if (cart.item_count === 0) {
        showEmptyCart();
        return;
      }
      
      // Build cart items HTML
      let cartItemsHTML = '<div class="cart-items">';
      
      cart.items.forEach(item => {
        const price = (item.final_price / 100).toFixed(2);
        const originalPrice = item.original_price > item.final_price ? (item.original_price / 100).toFixed(2) : null;
        const truncatedTitle = item.product_title.length > 70 ? item.product_title.substring(0, 70) + '...' : item.product_title;
        
        cartItemsHTML += `
          <div class="cart-item">
            <div class="cart-item-image">
              <img src="${item.image}" alt="${item.title}">
            </div>
            <div class="cart-item-details">
              <h6>${truncatedTitle}</h6>
              ${item.variant_title ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
              <div class="cart-item-price-row">
                <span class="qty-badge">${item.quantity}</span>
                <span class="multiply-icon">×</span>
                <div class="cart-item-price">
                  <span class="price">₹${price}</span>
                  ${originalPrice ? `<span class="original-price">₹${originalPrice}</span>` : ''}
                </div>
              </div>
            </div>
            <button class="cart-item-remove" data-remove-item="${item.key}" aria-label="Remove item">
              <i class="fas fa-times"></i>
            </button>
          </div>

        `;
      });
      
      cartItemsHTML += '</div>';
      
      // Update cart body
      cartSidebarBody.innerHTML = cartItemsHTML;
      
      // Update cart footer
      let footer = cartSidebarFooter;
      if (!footer) {
        footer = document.createElement('div');
        footer.className = 'cart-sidebar-footer';
        const content = document.querySelector('.cart-sidebar-content');
        if (content) content.appendChild(footer);
      }

      if (footer) {
        const totalPrice = (cart.total_price / 100).toFixed(2);
        footer.innerHTML = `
          <div class="cart-total">
            <span>Total:</span>
            <span class="cart-total-price">₹${totalPrice}</span>
          </div>
          <a href="/checkout" class="mz-btn mz-btn-primary checkout-btn">Proceed to Checkout</a>
          <a href="/cart" class="mz-btn mz-btn-outline">View Cart</a>
        `;
        footer.style.display = 'block';
      }
      
      // Re-setup remove buttons for newly added items
      setupRemoveButtons();
    })
    .catch(error => console.error('Error refreshing cart sidebar:', error));
}

// Show add to cart notification
function showAddToCartNotification(product) {
  // Create notification element
  const notification = document.createElement('div');
  notification.className = 'cart-notification';
  notification.innerHTML = `
    <div class="cart-notification-content">
      <i class="fas fa-check-circle"></i>
      <span>Added to cart successfully!</span>
    </div>
  `;
  
  // Add styles
  notification.style.cssText = `
    position: fixed;
    top: 80px;
    right: 20px;
    background: #fff;
    padding: 16px 24px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 10000;
    display: flex;
    align-items: center;
    gap: 12px;
    animation: slideInRight 0.3s ease;
  `;
  
  // Add to page
  document.body.appendChild(notification);
  
  // Remove after 3 seconds
  setTimeout(() => {
    notification.style.animation = 'slideOutRight 0.3s ease';
    setTimeout(() => {
      notification.remove();
    }, 300);
  }, 3000);
}

// Add CSS animations for notifications
const style = document.createElement('style');
style.textContent = `
  @keyframes slideInRight {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes slideOutRight {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(400px);
      opacity: 0;
    }
  }
  
  .cart-notification-content {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .cart-notification-content i {
    color: #22c55e;
    font-size: 20px;
  }
  
  .cart-notification-content span {
    color: #1a1a1a;
    font-weight: 500;
  }
  
  .cart-item-price-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
  }
  
  .qty-badge {
    background: #0066ff;
    color: white;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 600;
    min-width: 28px;
    text-align: center;
    display: inline-block;
  }
  
  .multiply-icon {
    color: #666;
    font-size: 14px;
    font-weight: 500;
  }
  
  .cart-item-price {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;
document.head.appendChild(style);
